module.exports = __webpack_public_path__ + "static/media/wohnesszimmer.5d444007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/slider/slides/wohnesszimmer.jpg
// module id = 350
// module chunks = 0